import { PulseBaseProvider } from '../../base-classes';

const _getArityOptInCacheKey = 'getArityOptIn';
const _getArityOptInUri = '/api/commuter/arity/v1';

export class ArityProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_getArityOptInCacheKey] = this.getArityOptInSyncer.bind(this);
    }

    async getArityOptInSyncer(params) {
        const {
            id,
            syncParams,
            resolve,
            reject
        } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            verbose: syncParams.verbose
        };

        return await super.syncData(
            syncParams.key
            , id
            , queryParams
            , _getArityOptInUri
            , resolve
            , reject
            , null
            , syncParams.pulseApi
            , null
        );
    }

    async getArityOptIn(stdParameters, verbose = false, refresh = false) {
        const syncParams = {
            verbose: !!verbose,
            refresh
        };

        const id = JSON.stringify(syncParams);
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_getArityOptInCacheKey, id);
        }
        return await super.loadFromStorage(_getArityOptInCacheKey, id, syncParams);
    }
}